import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as CLICKSTREAM, type ClickstreamPayload } from '@zg-rentals/clickstream';
import { tracker as COMSCORE } from '@zg-rentals/comscore/client';
import type { RentalApplication, ZrmListingInfo, ZrmUserInfo } from '@zg-rentals/clickstream';
import type { MarketingInfo } from './types';

export const analytics = defineAnalytics({ COMSCORE, CLICKSTREAM });

export const trackComscoreEvent = analytics.createTrackEvent('COMSCORE');

export const trackUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ClickstreamPayload<ZrmUserInfo>>('CLICKSTREAM');

export const trackMarketingUserEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ClickstreamPayload<ZrmUserInfo & { marketing_info: MarketingInfo }>
>('CLICKSTREAM');

export const trackListingUserEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ClickstreamPayload<ZrmListingInfo & ZrmUserInfo>
>('CLICKSTREAM');

export const trackRentalApplicationEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ClickstreamPayload<RentalApplication>
>('CLICKSTREAM');
